import keyMirror from 'key-mirror';
import { createActions } from 'redux-actions';

export const constants = keyMirror({
    REHYDRATION_COMPLETED: null,
    SET_VERSION: null,
    SET_BREADCRUMB: null,
    ADD_JOYRIDE_STEP: null,

    CONTACT_REQUEST: null,
    CONTACT_SUCCESS: null,
    CONTACT_FAILURE: null,

    BOOK_SESSION_REQUEST: null,
    BOOK_SESSION_SUCCESS: null,
    BOOK_SESSION_FAILURE: null,

    GET_STATS_REQUEST: null,
    GET_STATS_SUCCESS: null,
    GET_STATS_FAILURE: null,

    GET_GENERAL_PAGE_REQUEST: null,
    GET_GENERAL_PAGE_SUCCESS: null,
    GET_GENERAL_PAGE_FAILURE: null,

    GET_APP_BRAND_REQUEST: null,
    GET_APP_BRAND_SUCCESS: null,
    GET_APP_BRAND_FAILURE: null
});

export const {
    setVersion,
    setBreadcrumb,
    rehydrationCompleted
} = createActions(
    constants.SET_VERSION,
    constants.SET_BREADCRUMB,
    constants.REHYDRATION_COMPLETED
);

export const {
    contactRequest,
    contactSuccess,
    contactFailure
} = createActions(
    constants.CONTACT_REQUEST,
    constants.CONTACT_SUCCESS,
    constants.CONTACT_FAILURE
);

export const {
    bookSessionRequest,
    bookSessionSuccess,
    bookSessionFailure
} = createActions(
    constants.BOOK_SESSION_REQUEST,
    constants.BOOK_SESSION_SUCCESS,
    constants.BOOK_SESSION_FAILURE
);

export const {
    getStatsRequest,
    getStatsSuccess,
    getStatsFailure
} = createActions(
    constants.GET_STATS_REQUEST,
    constants.GET_STATS_SUCCESS,
    constants.GET_STATS_FAILURE
);

export const {
    getGeneralPageRequest,
    getGeneralPageSuccess,
    getGeneralPageFailure
} = createActions(
    constants.GET_GENERAL_PAGE_REQUEST,
    constants.GET_GENERAL_PAGE_SUCCESS,
    constants.GET_GENERAL_PAGE_FAILURE
);

export const {
    getAppBrandRequest,
    getAppBrandSuccess,
    getAppBrandFailure
} = createActions(
    constants.GET_APP_BRAND_REQUEST,
    constants.GET_APP_BRAND_SUCCESS,
    constants.GET_APP_BRAND_FAILURE
);



/** WEBPACK FOOTER **
 ** ./src/core/global/globalActions.js
 **/